<div class="p1 p-a-2 p-l-3 p-r-3 b-a inline-block center cursor-pointer _box"
     [class.selected]="selected"
     [style.min-width.px]="46">
    <ng-content>
    </ng-content>
</div>